export const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;
export const API_URL = process.env.REACT_APP_API_URL;
